import React, { useState, useRef, useEffect } from "react";
import "../styles/AccountDropdown.css";

const AccountDropdown = ({ userInfo, handleLogout }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  // クリック外しで閉じる
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="AccountDropdown-container" ref={dropdownRef}>
      <div className="AccountDropdown-icon" onClick={() => setOpen(!open)}>
        👤
      </div>
      {open && (
        <div className="AccountDropdown-menu">
          <div className="AccountDropdown-info">
            ログイン: {userInfo.username} <br />
            {userInfo.register_name}［ID:{userInfo.register_id}］
          </div>
          <button onClick={handleLogout} className="AccountDropdown-logout">
            ログアウト
          </button>
        </div>
      )}
    </div>
  );
};

export default AccountDropdown;
